<template>
    <a v-if="url" :href="url" :class="className">{{ content }}</a>
    <span v-else>{{ content }}</span>
</template>

<script>
import { buildUrl, getRouteByName, buildRoute } from '../../helpers'
export default {
    props: {
        object: {
            type: Object, // {type, id}
            required: true,
        },
        content: {
            type: String,
            required: false,
        },
        className: {
            type: String,
            required: false,
        }
    },
    data(){
        return {
        }
    },
    computed: {
        route(){
            switch(this.object.type) {
                case 'opportunity':
                    return 'prospection.opportunity.overview';
                case 'estimate':
                case 'invoice':
                case 'creditnote':
                case 'delivery':
                case 'proforma':
                case 'order':
                    return 'invoicing.{type}.overview'.replace('{type}', this.object.type);
                case 'purInvoice':
                case 'purCreditNote':
                case 'purDelivery':
                case 'purOrder':
                    return 'purchase.{type}.overview'.replace('{type}', this.object.type);
                default:
                    return '';
            }
        },
        url(){
            return this.getUrl(this.object)
        }
    },
    methods: {
        buildUrl,
        buildRoute,
        getRouteByName,
        getUrl(object){
            return this.getRouteByName(this.route, [{key: 'id', value: object.id}]);
        }
            
    }
}
</script>
